module.exports = __webpack_public_path__ + "static/media/ios-eye-off.6de634b2.svg";